import { makeParams } from "@/utils/helper"
import { API } from "."
import { ReadPositionsResponse } from "@/types/position"

export const readPositions = async (
  level: number,
  sportType?: string,
  ordering?: "position" | "group",
) => {
  const params = makeParams({ level, sportType, ordering })

  return await API.get<ReadPositionsResponse>("/positions", { params })
}
